import React from 'react';

const FullWidthPhoto = ({ photo, alt, caption }) => {
  return (
    <div className="fullWidth">
      <img src={photo} alt={alt} />
      <p className="inline__caption__text" style={{ marginLeft: '1.2rem' }}>
        {caption}
      </p>
    </div>
  );
};

export default FullWidthPhoto;
